/*
 This service allows to persist store information between refreshes
 */

export const loadStore = () => {
  try {

      const serializedState = localStorage.getItem('state');

      if (serializedState == null) {
          return undefined; // let reducer initialize the state
      }
      return JSON.parse(serializedState);
  } catch(err) {
      return undefined; // let reducer initialize the state
  }
};

export const saveStore = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (err) {

    }
};

export const resetStore = (state) => {
    localStorage.removeItem('state');
};